export enum AccessTypeSelection {
    INFORMATION_ONLY = 'INFO_ONLY',
    LIMITED_ACCESS = 'LIMITED',
    FULL_AUTHORITY = 'FULL',
}
